<template>
	<v-chip
		:label="label"
		:size="size"
		:color="color"
		:variant="variant"
		:closable="closable"
		class="ao-chip"
		@click:close="$emit('click:close')"
	>
		<div class="ao-chip__content-wrapper">
			<slot name="prepend-icon">
				<AoIcon
					v-if="prependIcon"
					:iconName="prependIcon"
					class="ao-chip__icon ao-chip__icon--prepend"
				/>
			</slot>

			<slot name="default">
				{{ item[itemTitle] }}
			</slot>

			<slot name="append-icon">
				<AoIcon
					v-if="appendIcon"
					:iconName="appendIcon"
					class="ao-chip__icon ao-chip__icon--append"
				/>
			</slot>
		</div>
	</v-chip>
</template>

<script setup>
import AoIcon from './AoIcon.vue'

defineProps({

	item: {
		type: Object,
		default: null,
	},

	itemTitle: {
		type: String,
		default: 'title',
	},

	label: {
		type: Boolean,
		default: true,
	},

	size: {
		type: String,
		default: 'default',
		validator: (v) => ['x-small', 'small', 'default', 'large', 'x-large'].includes(v),
	},

	color: {
		type: String,
	},

	density: {
		type: String,
		default: 'compact',
	},

	variant: {
		type: String,
	},

	closable: {
		type: Boolean,
		default: false,
	},

	prependIcon: {
		type: String,
	},

	appendIcon: {
		type: String,
	},
})

defineEmits({
	'click:close': null,
})
</script>

<style lang="scss">
.v-chip.ao-chip {
	.ao-chip__content-wrapper {
		display: flex;
		align-items: center;
		gap: 4px;
		line-height: 1;
	}

	@mixin chip-size($name, $height, $font-size, $padding-x, $radius) {
		&.v-chip--#{$name}-size {
			height: $height;
			border-radius: $radius;
		}
	}

	@include chip-size('x-small', 24px, 10px, 8px, 3px);
	@include chip-size('small', 28px, 11px, 10px, 4px);
	@include chip-size('default', 36px, 12px, 12px, 6px);
	@include chip-size('large', 40px, 14px, 14px, 8px);
	@include chip-size('x-large', 44px, 16px, 16px, 10px);
}
</style>
